export default {
    forum_management: 'Forum Management',
    tool_management: 'Tool Management',
    user_management: 'User Management',
    ticket_management: 'Ticket Management',
    order_management: 'Order Management',
    website_configuration: 'Website Configuration',
    title: 'Conference Title 11',
    welcome: 'Welcome to the {name} Conference Backstage Management',
    count_total: 'Sales Quantity Statistics',
    sales_number: 'Sales Quantity',
    money_total: 'Sales Amount Statistics',
    noAuth_title: 'You do not have permission to access this page',
    noAuth_subtitle: 'Sorry, you do not have permission to access this page or the route is incorrect.',
    no_exist_title: 'The page you are accessing does not exist or you do not have permission',
    no_sub_title: 'Sorry, you do not have permission to access this page or the route is incorrect.',
    back_home: 'Back to Home Page',
    tips: 'Tips',
    ok: 'OK',
    cancel: 'Cancel',
    unknown: 'Unknown',
    confirm_delete_data: 'Are you sure you want to delete this data?',
    actions: 'Actions',
    pagination_total: 'Total: {value} items',
    delete_success: 'Delete Successful',
    delete_fail: 'Delete Failed',
    copy_link: 'Copy Link',
    edit: 'Edit',
    new: 'New',
    add: 'Add',
    delete: 'Delete',
    operate_scuuess: 'Operation Successful',
    operate_fail: 'Operation Failed',
    confirm_delete: 'Confirm Delete',
    copy_success: 'Copy Successful',
    query: 'Query',
    open: 'Open',
    close: 'Close',
    modify_success: 'Modify Successful',
    add_success: 'Add Successful',
    search: 'Search',
    show: 'Show',
    hide: 'Hide',
    modify: 'Modify',
    status: 'Status',
    index: 'Serial Number',
    selected: 'Selected',
    desc: 'Description',
    keyword: 'Keyword',
    no_dev: 'Not yet developed',
    date: 'Date',
    create_time: 'Creation Time',
    user_name: 'User Name',
    mobile: 'Mobile Phone',
    order: 'Order Number',
    both: 'All',
    details: 'Details',
    submit_time: 'Submit Time',
    cn: 'Chinese',
    en: 'English',
    list: 'List',
    mobile_name: 'Mobile Phone/Name',
    company: 'Company',
    name: 'Name',
    department: 'Department',
    select_at_least_one: 'Please select at least one item',
    default_text: 'Default',
    no_show: 'Hide',
    cn_en: 'Chinese and English',
    sort: 'Sorting',
    time: 'Time',
    clear: 'Clear',
    class_name: 'Category',
    un_select_del: 'You have not selected an item to delete.',
    del_selected: 'Are you sure you want to delete the selected items?',
    cannot_back: 'The deleted data cannot be recovered!',
    first: 'No.',
    the_session: 'Session',
    del_current: 'Are you sure you want to delete this item?',
    save: 'Save',
    cn_people: 'Chinese Guests',
    en_people: 'Foreign Guests',
    submit: 'Submit',
    upload: 'Upload',
    update_success: 'Update Successful',
    seat_system: 'Guest Seating System',
    sign_in_system: 'On-site Sign-in System',
    survey_system: 'Questionnaire Survey',
    upload_fail: 'Upload Failed. Image size should not exceed 5M.',
    upload_error: 'Upload Error',
    placeholder: 'Please enter content...',
    content_length_limit: 'Content cannot exceed {length} characters',
    total: 'Total',
    selected: 'Selected:',
    word_count: 'Word Count:',
    word_count_limit: 'Word Count Limit:',
    word_count_limit_max: 'Maximum Word Count: {maxLength}',
    content_length_limit_max: 'Content cannot exceed {maxLength} characters',
    email: 'Email',
    click_download: 'Click to Download',
    get_verification_code: 'Get Verification Code',
    please_fill_in_the_required_fields: 'Please fill in the required fields',
    the_selected_number_cannot_exceed: 'The number of selected items cannot exceed {count}.',
    seconds_later_resend: 'Resend available in {seconds} seconds',
    country: 'Country',
    province: 'Province',
    city: 'City',
    district: 'District',
    is_key_value: 'Whether it is a key-value pair',
    add_option: 'Add Option',
    min_count: 'Minimum number of items is {min}.',
    teaching_title: 'Technical Title',
    download_file: 'Download File',
    download_template: 'Download Template',
    upload_success: 'Upload Successful',
    upload_failed: 'Upload Failed',
    download_center: 'Download Task Center',
    downloading: 'Downloading',
    download: 'Download',
    download_columns: {
        name: 'Name',
        status: 'File Status',
        error_msg: 'Error Message',
        time: 'Creation Time',
        file_size: 'File Size',
        action: 'Action'
    },
    download_center_title: 'Task Center Download',
    unknown_problem: 'Unknown Problem',
    identity_verification_failed: 'Identity Verification Failed',
    page_not_found: 'The page you are accessing does not exist.',
    data_loading_error: 'Data Loading Error',
    new_version_detected: 'A new system version has been detected. You will be automatically switched to the latest version in 2 seconds.',
    foreign_identity: 'Foreign Identity',
    domestic_identity: 'Domestic Identity'
};
